import { PickableColor } from "../../components/atoms/color-picker/color-picker";
import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";
import { TBudgetProfileLevelDedicatedHours } from "./read-budgets-levels-detailed-by-id";

const { REACT_APP_BASE_URL } = process.env;

type TReadBudgets = {
    filter?: string;
    page: number;
    length: number;
    budgetTypeIds?: string[];
    clientIds?: string[];
    statusIds?: string[];
    isArchived?: boolean;
};

export type BudgetStatus = "approved" | "refused" | "waiting" | "progress";

export type TLevel = {
    Level: {
        id_e: string;
        name: string;
        MainLevel: { color: string };
        DetailedLevel: {
            Parent: {
                id_e: string;
                name: string;
            };
        };
        Children: {
            Level: {
                name: string;
            };
            level_id_e: string;
        }[];
    }[];
    id_e: string;
    levelOrder: 1 | 2 | 3;
    name: string;
};

export type TBudgetProfile = {
    BudgetProfileTimeDependancy: {
        DependsOn: {
            Profile: {
                name: string;
            };
            id_e: string;
        };
    }[];
    BudgetProfileLevelDedicatedHours: TBudgetProfileLevelDedicatedHours;
    Profile: { id_e: string; name: string; abbreviation: string };
    id_e: string;
    name: string;
    costPerHour: string;
    dependencyPercentage?: number | null;
    dependencyMode: string | null;
    startWeek: number;
    hoursPerDay: number;
    efficiencyPercentage: number;
    additionalCollaborators: number;
    reductionPercentage: number;
    hoursEstimationStatus?: string;
    responsible: {
        avatar: string;
        id_e: string;
        name: string;
    } | null;
    totals: {
        totalHours: number;
        totalPrice: number;
    };
};

export type TReadBudgetsResponse = {
    id_e: string;
    name: string;
    color: PickableColor;
    secondary_color: string;
    status: BudgetStatus;
    description: string;
    client: {
        id_e: string;
        name: string;
    };
    organization: {
        id_e: string;
        name: string;
    };
    BudgetProfiles: TBudgetProfile[];
    type: {
        id_e: string;
        name: string;
    };
    Status: {
        id_e: string;
        name: string;
        color: string;
        organization_id_e: string | null;
    };
    totalHours: number;
    totalPrice: number;
    isArchived: boolean;
    created_at: string;
    updated_at: string;
    LevelConfig: TLevel[];
    project_id_e?: string;
};

export const defaultReadBudgetData: TReadBudgetsResponse = {
    BudgetProfiles: [],
    color: "#0B49EC",
    client: {
        id_e: "",
        name: "",
    },
    created_at: "",
    description: "",
    id_e: "",
    isArchived: false,
    LevelConfig: [],
    name: "",
    organization: {
        id_e: "",
        name: "",
    },
    secondary_color: "#0B49EC",
    Status: {
        id_e: "",
        name: "",
        color: "",
        organization_id_e: "",
    },
    status: "waiting",
    totalHours: 0,
    totalPrice: 0,
    type: {
        id_e: "",
        name: "",
    },
    updated_at: "",
    project_id_e: "",
};

export default async (
    params: TReadBudgets = { length: 10, page: 1, isArchived: false }
) => {
    const httpResponse = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/budget`,
        method: "get",
        params,
        headers: { auth: true },
    });
    const { body, statusCode } = httpResponse;

    return handleStatusCases<TReadBudgetsResponse[]>({
        body,
        statusCode,
    });
};
